<template>
  <Loading :loading="loading">
    <div class="memberBiz">
      <div class="container">
        <div class="row">
          <Breadcrumbs/>
        </div>
      </div>
      <div class="row">
        <!-- Get content for page -->
        <!-- Catch loaded event from wordpress and then show content -->
        <WordpressContentPage
          pageSlug="member-biz-top"
          class="col-12"
          :showLoading="false"
          v-on:loaded="wpContentLoaded"
        />
      </div>
      <div class="container">
        <div class="row">
          <div
            v-for="location in locations"
            class="col-12 col-sm-6 col-md-3 text-center memberBizItem"
            :key="location.id"
          >
            <router-link :to="{name:'memberBizLocation', params:{location: location.id}}">
              <div class="title">{{location.category}}</div>
              <img :src="image(location.filename)">
              <div class="btn btn-primary">Learn More</div>
            </router-link>
          </div>
        </div>
        <WordpressContentPage
          pageSlug="member-biz-bottom"
          class="col-12 mt-3"
          :showLoading="false"
        />
      </div>
    </div>
  </Loading>
</template>

<script>
import WordpressContentPage from "@/wordpress/WordpressContentPage";
import Loading from "@/components/loading/Loading";
import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";

export default {
  name: "MemberBiz",
  components: {
    WordpressContentPage,
    Loading,
    Breadcrumbs
  },
  data() {
    return {
      //loading is true until wordpress content has loaded
      loading: true
    };
  },
  created() {},
  methods: {
    image(filename) {
      let base = "/resources/images/content/";

      return base + filename;
    },
    wpContentLoaded() {
      this.loading = false;
    }
  },
  computed: {
    locations() {
      if (this.$store.state.reference.categories) {
        //this is hardcoded to get the locations of member biz
        return this.$store.state.reference.categories["1635"].children;
      }
      return {};
    }
  }
};
</script>

<style lang="scss" scoped>
.memberBizItem {
  text-align: center;
  position: relative;
  margin-bottom: 20px;

  div.title {
    &:hover {
      text-decoration: underline;
    }
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    text-decoration: none;
    color: $CTred;
    font-weight: bold;
    font-size: 1.3em;
    display: block;
    padding: 20px;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1;
  }
  img {
    display: block;
    max-width: 100%;
    height: auto;
    margin-bottom: 10px;
    border-radius: $imageRounding;
    margin-left: auto;
    margin-right: auto;
  }
}

@include media-breakpoint-down(md){
  .memberBizItem{
    margin-bottom: 30px;
    margin-top: 20px;
  }
}
</style>
